import { useState } from "react";
import { PageHeader } from "../../../components/PageHeader/index.js";
import VerifiedUsersTab from "./VerifiedUsersTab.js";
import UnverifiedFilesTab from "./UnverifiedFilesTab.js";
import MoveToFirmTab from "./MoveToFirmTab.js";
import RoleProvisioningTab from "./RoleProvisioningTab.js";
import styles from "./Users.module.css";

type TabId = "verified" | "unverified" | "move-to-firm" | "role-provisioning";

// Move to Firm first and as the default: Verified With Firms is slow to load,
// so it must not be what the page opens on.
const TABS: ReadonlyArray<{ id: TabId; label: string }> = [
  { id: "move-to-firm", label: "Move to Firm" },
  { id: "role-provisioning", label: "Role Provisioning" },
  { id: "verified", label: "Verified With Firms" },
  { id: "unverified", label: "Unverified Files" },
];

function UsersPage() {
  const [activeTab, setActiveTab] = useState<TabId>("move-to-firm");

  return (
    <div className={styles.wrapper}>
      <PageHeader title="Users" subtitle="Account user operations" />

      <div className={styles.tabs}>
        {TABS.map(tab => (
          <button
            key={tab.id}
            type="button"
            className={activeTab === tab.id ? styles.tabActive : styles.tab}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "move-to-firm" && <MoveToFirmTab />}
      {activeTab === "role-provisioning" && <RoleProvisioningTab />}
      {activeTab === "verified" && <VerifiedUsersTab />}
      {activeTab === "unverified" && <UnverifiedFilesTab />}
    </div>
  );
}

export default UsersPage;
